module.exports = __webpack_public_path__ + "static/media/504GriffinStNW_2018-06-05_7.f6b915c5.jpg";